import {Agent} from "./agent";

export class Agency {
  id: string;
  accounts?: Agent[];
  name: string;
  iata_number?: string;
  image_url?: string;
  role?: string;
  agent_id?: string;
  status?: string;
  is_default_agency?: boolean;
  active_subagencies?: {id: string, name: string}[];
}

export class Account {
  api_key: string;
  email: string;
  id: string;
  invited: boolean;
  name: string;
  role: string;
  status: string;
  username: string;
}
